//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ProfileView',
  data() {
    return {
      token: localStorage.token || '',
      tab: 'biodata',
      loadingData: false,
      savingProfile: false,
      savingPassword: false,

      isPwd1: true,
      isPwd2: true,

      // Form Profile
      form: {
        profil_id: '',
        id: '',
        nama: '',
        username: '',
        email: '',
        hp: '',
        level: '',
        kelas: '',

        provinsi: '',
        kabupaten: '',
        kecamatan: '',
        desa_kelurahan: '',
      },

      // Original copy for reset
      originalForm: {},

      // Form Password
      passwordForm: {
        password: '',
        confirmPassword: '',
      },
    };
  },
  computed: {
    isPasswordMatch() {
      return (
        this.passwordForm.password &&
        this.passwordForm.password === this.passwordForm.confirmPassword
      );
    },
  },
  methods: {
    // Inisial avatar
    getInitials(name) {
      if (!name) return 'U';
      const parts = name.trim().split(' ');
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return name.substring(0, 2).toUpperCase();
    },

    // Get View Profile Data
    getView(isManualRefresh = false) {
      this.loadingData = true;

      // Ambil profile lokal terlebih dahulu
      let localProf = {};
      try {
        if (localStorage.profile) {
          localProf = JSON.parse(localStorage.profile);
        }
      } catch (e) {
        console.error('Error parse localStorage.profile', e);
      }

      const userId = localProf.id || this.form.profil_id || (this.$store.state.lcProfile ? this.$store.state.lcProfile.id : '');

      if (!userId) {
        this.loadingData = false;
        return;
      }

      fetch(this.$store.state.url.URL_REGISTRASI + 'view_contoh3', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'kikensbatara ' + localStorage.token,
        },
        body: JSON.stringify({
          id: userId,
          provinsi: localProf.provinsi || this.form.provinsi,
          kabupaten: localProf.kabupaten || this.form.kabupaten,
          kecamatan: localProf.kecamatan || this.form.kecamatan,
          desa_kelurahan: localProf.desa_kelurahan || this.form.desa_kelurahan,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.loadingData = false;
          if (res_data && res_data.data && res_data.data.length > 0) {
            const data = res_data.data[0];
            this.populateData(data);
            if (isManualRefresh) {
              this.$q.notify({
                type: 'positive',
                message: 'Data profil berhasil dimuat ulang!',
                position: 'top',
                timeout: 1500,
              });
            }
          } else {
            // Fallback to local profile
            this.populateData(localProf);
          }
        })
        .catch((err) => {
          this.loadingData = false;
          console.error('Error fetching profile:', err);
          this.populateData(localProf);
        });
    },

    // Populate data into form
    populateData(data) {
      if (!data) return;

      this.form.id = data.id || data._id || '';
      this.form.profil_id = data.id || data._id || '';
      this.form.nama = data.nama || '';
      this.form.username = data.username || '';
      this.form.email = data.email || '';
      this.form.hp = data.hp || '';
      this.form.level = data.level || '';
      this.form.kelas = data.kelas || '';

      this.form.provinsi = data.provinsi || '';
      this.form.kabupaten = data.kabupaten || '';
      this.form.kecamatan = data.kecamatan || '';
      this.form.desa_kelurahan = data.desa_kelurahan || '';

      this.originalForm = JSON.parse(JSON.stringify(this.form));
    },

    // Reset Form
    resetForm() {
      if (this.originalForm && Object.keys(this.originalForm).length > 0) {
        this.form = JSON.parse(JSON.stringify(this.originalForm));
        this.$q.notify({
          type: 'info',
          message: 'Form telah dikembalikan ke kondisi semula.',
          position: 'top',
          timeout: 1500,
        });
      }
    },

    // Save / Edit Profile
    saveProfile() {
      // Validasi
      if (!this.form.nama || this.form.nama.trim() === '') {
        this.$q.notify({ type: 'negative', message: 'Nama lengkap wajib diisi!', position: 'top' });
        return;
      }
      if (!this.form.username || this.form.username.trim() === '') {
        this.$q.notify({ type: 'negative', message: 'Username wajib diisi!', position: 'top' });
        return;
      }
      if (!this.form.email || this.form.email.trim() === '') {
        this.$q.notify({ type: 'negative', message: 'Email wajib diisi!', position: 'top' });
        return;
      }

      this.savingProfile = true;

      const payload = {
        id: this.form.id,
        nama: this.form.nama.trim(),
        username: this.form.username.trim(),
        email: this.form.email.trim(),
        hp: this.form.hp ? this.form.hp.trim() : '',
        level: this.form.level,
        kelas: this.form.kelas,
        provinsi: this.form.provinsi,
        kabupaten: this.form.kabupaten,
        kecamatan: this.form.kecamatan,
        desa_kelurahan: this.form.desa_kelurahan,
      };

      fetch(this.$store.state.url.URL_REGISTRASI + 'editData', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'kikensbatara ' + localStorage.token,
        },
        body: JSON.stringify(payload),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.savingProfile = false;
          if (res_data.success) {
            this.$q.notify({
              type: 'positive',
              message: res_data.message || 'Profil berhasil diperbarui!',
              position: 'top',
              icon: 'check_circle',
              timeout: 2000,
            });

            // Update localStorage & Vuex Store
            try {
              let curProf = {};
              if (localStorage.profile) {
                curProf = JSON.parse(localStorage.profile);
              }
              const updatedProf = { ...curProf, ...payload };
              localStorage.setItem('profile', JSON.stringify(updatedProf));
              if (this.$store && this.$store.state) {
                this.$store.state.lcProfile = updatedProf;
              }
            } catch (err) {
              console.error('Error updating localStorage profile', err);
            }

            this.originalForm = JSON.parse(JSON.stringify(this.form));
            this.getView();
          } else {
            this.$q.notify({
              type: 'negative',
              message: res_data.message || 'Gagal memperbarui profil.',
              position: 'top',
              timeout: 2500,
            });
          }
        })
        .catch((error) => {
          this.savingProfile = false;
          console.error('Error saving profile:', error);
          this.$q.notify({
            type: 'negative',
            message: 'Terjadi kesalahan server: ' + error.message,
            position: 'top',
          });
        });
    },

    // Save Password
    savePassword() {
      if (!this.passwordForm.password || this.passwordForm.password.trim() === '') {
        this.$q.notify({ type: 'negative', message: 'Kata sandi baru wajib diisi!', position: 'top' });
        return;
      }
      if (this.passwordForm.password.length < 6) {
        this.$q.notify({ type: 'negative', message: 'Kata sandi minimal harus 6 karakter!', position: 'top' });
        return;
      }
      if (this.passwordForm.password !== this.passwordForm.confirmPassword) {
        this.$q.notify({ type: 'negative', message: 'Konfirmasi kata sandi tidak cocok!', position: 'top' });
        return;
      }

      this.savingPassword = true;

      fetch(this.$store.state.url.URL_REGISTRASI + 'editPassword', {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          authorization: 'kikensbatara ' + localStorage.token,
        },
        body: JSON.stringify({
          id: this.form.id,
          username: this.form.username,
          password: this.passwordForm.password,
        }),
      })
        .then((res) => res.json())
        .then((res_data) => {
          this.savingPassword = false;
          if (res_data.success) {
            this.$q.notify({
              type: 'positive',
              message: res_data.message || 'Kata sandi berhasil diubah!',
              position: 'top',
              icon: 'lock',
              timeout: 2500,
            });
            this.resetPasswordForm();
          } else {
            this.$q.notify({
              type: 'negative',
              message: res_data.message || 'Gagal mengubah kata sandi.',
              position: 'top',
              timeout: 2500,
            });
          }
        })
        .catch((error) => {
          this.savingPassword = false;
          console.error('Error editPassword:', error);
          this.$q.notify({
            type: 'negative',
            message: 'Terjadi kesalahan: ' + error.message,
            position: 'top',
          });
        });
    },

    // Reset Password Form
    resetPasswordForm() {
      this.passwordForm = {
        password: '',
        confirmPassword: '',
      };
    },
  },

  mounted() {
    this.getView();
  },
};
